export { default as ExclamationSolidIcon } from './ExclamationSolidIcon';
